import React from "react";

const HeaderSocials = () => {
  return (
    <div className="home__socials">
      <a href="https://www.instagram.com/pixeledge.ui/" className="home__social-link" target="blank">
        <i className="fa-brands fa-instagram"></i>
      </a>

      <a href="https://www.behance.net/saloniverma22" className="home__social-link" target="blank">
        <i className="fa-brands fa-behance"></i>
      </a>

      <a href="https://dribbble.com/salonii_" className="home__social-link" target="blank">
        <i className="fa-brands fa-dribbble"></i>
      </a>

      <a href="https://www.linkedin.com/in/saloni-verma-sv/" className="home__social-link" target="blank">
        <i className="fa-brands fa-linkedin"></i>
      </a>
    </div>
  );
};

export default HeaderSocials;
